import React from "react";

function SvgSearch() {
    return (
        <svg width="20" height="20" viewBox="0 0 32 32">
            <g fill="#fff" stroke="#606060">
                <path
                    stroke="none"
                    d="M12 0c6.627417 0 12 5.372583 12 12 0 2.5477049-.7939493 4.909973-2.1479242 6.8528806L30.5 27.5c.8284271.8284271.8284271 2.1715729 0 3-.8284271.8284271-2.1715729.8284271-3 0l-8.6471194-8.6479242C16.909973 23.2060507 14.5477049 24 12 24 5.372583 24 0 18.627417 0 12S5.372583 0 12 0zm0 4c-4.418278 0-8 3.581722-8 8s3.581722 8 8 8 8-3.581722 8-8-3.581722-8-8-8z"
                ></path>
            </g>
        </svg>
    );
}

export function SvgDirections() {
    return <svg width="25" height="25" viewBox="0 0 40 40">
        <g fill="#606060" stroke="#606060">
            <g stroke="red">
                <path
                    d="M23.17157 3.17157l14.34315 14.34315c1.5621 1.5621 1.5621 4.09476 0 5.65685L23.17157 37.51472c-1.5621 1.5621-4.09475 1.5621-5.65685 0L3.17157 23.17157c-1.5621-1.5621-1.5621-4.09475 0-5.65685L17.51472 3.17157c1.5621-1.5621 4.09476-1.5621 5.65685 0zM24.4777 13c-.23451 0-.42955.16697-.47.38716L24 13.472v3.278h-8l-.19204.00518c-1.7801.09626-3.20652 1.52267-3.30278 3.30278L12.5 20.25v5.88889c0 .51283.38604.9355.88338.99327l.11662.00673h1c.51284 0 .9355-.38604.99327-.88338l.00673-.11662V20.25l.00806-.08988c.03704-.20409.19797-.36502.40206-.40206L16 19.75h8v3.278c0 .10717.03697.21115.10473.29484.1465.18094.40029.22712.59957.12078l.07185-.04707 6.04455-4.77796a.47489.47489 0 00.0746-.07371c.1465-.18094.13639-.43573-.01235-.60448l-.06225-.05894-6.0446-4.77803C24.6914 13.03648 24.58616 13 24.4777 13z"
                    fill="white"
                ></path>
            </g>
        </g>
    </svg>
}

export default SvgSearch;
